import React, { useState, useCallback, useEffect } from 'react'
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js'
import { useNavigate, useParams } from 'react-router-dom'

import { ROUTES } from '@common'
import { Loader } from '@components'
import { ErrorTrackingAPI } from '@services'

const CheckoutForm = ({ onPaymentSuccess }) => {
    const { orderId } = useParams()
    const navigate = useNavigate()
    const stripe = useStripe()
    const elements = useElements()

    const [message, setMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const handlePayment = useCallback(async () => {
        if (!stripe || !elements || isLoading) {
            return
        }

        // Ensure body exists before calling Stripe API
        // This prevents "Stripe.js requires that your page has a <body> element" error
        if (!document.body) {
            setMessage('Page is not ready. Please refresh and try again.')
            return
        }

        setIsLoading(true)
        setMessage(null)

        try {
            // eslint-disable-next-line no-unused-vars
            const { paymentIntent, error } = await stripe.confirmPayment({
                elements,
                redirect: 'if_required',
            })

            if (paymentIntent?.status === 'succeeded') {
                // Notify parent component that payment was successful
                if (onPaymentSuccess) {
                    onPaymentSuccess()
                }
                navigate(
                    ROUTES.Payment.check
                        .replace(':orderId', orderId)
                        .replace(':paymentIntentId', paymentIntent.id)
                        .replace(':clientSecret', paymentIntent.client_secret),
                    { replace: true }
                )
            } else {
                setIsLoading(false)
                if (window.location.pathname.includes('/payment/')) {
                    window.history.go(-1)
                }
            }

            // if (error) {
            //     const { code, message, payment_intent } = error
            //     setMessage(`Error: ${message}`)

            //     if (payment_intent?.status === 'canceled') {
            //         const errorMsg = 'Payment limit reached, Please scan QR code to order again, or contact the cashier.'
            //         toast.error(errorMsg)
            //         setMessage(errorMsg)
            //         return
            //     }

            //     switch (code) {
            //         case 'insufficient_funds':
            //             toast.error('Insufficient funds, Please try again.')
            //             break
            //         case 'card_declined':
            //             toast.error('Card declined, Please try again.')
            //             break
            //         case 'processing_error':
            //             toast.error('Processing error, Please try again.')
            //             break
            //         default:
            //             toast.error('An unexpected error occurred. Please try again.')
            //             break
            //     }
            // }
            // } else if (paymentIntent?.status === 'succeeded') {
            //     navigate(
            //         ROUTES.Payment.check
            //             .replace(':orderId', orderId)
            //             .replace(':paymentIntentId', paymentIntent.id)
            //             .replace(':clientSecret', paymentIntent.client_secret)
            //     )
            // } else {
            //     setMessage('Payment failed! Please try again.')
            //     toast.error('Payment failed! Please try again.')
            // }
        } catch (error) {
            setMessage('An unexpected error occurred. Please try again.')
            ErrorTrackingAPI.sendError(error, 'Stripe', 'handlePayment', 'SystemError')
        } finally {
            setIsLoading(false)
        }
    }, [stripe, elements, isLoading, navigate, orderId])

    useEffect(() => {
        const paymentElement = elements?.getElement('payment')
        if (paymentElement) {
            const handleReady = () => {
                // Ensure body exists before handling payment
                // This prevents "Stripe.js requires that your page has a <body> element" error
                if (document.body) {
                    handlePayment()
                } else {
                    console.warn('Body element not found when payment element is ready')
                    setMessage('Page is not ready. Please refresh and try again.')
                }
            }

            paymentElement.on('ready', handleReady)

            // Cleanup: remove event listener when component unmounts
            return () => {
                if (paymentElement) {
                    paymentElement.off('ready', handleReady)
                }
            }
        }
    }, [elements, handlePayment])

    return (
        <div>
            {isLoading && <Loader />}
            <PaymentElement />
            {isLoading && <p className="font-weight-bold text-center mt-3">Processing...</p>}
            <div className="d-flex flex-column align-items-center">
                {message && <p className="text-danger font-weight-bold text-center mt-3">{message}</p>}
                {/* <Button
                    disabled={isLoading}
                    color="primary"
                    className="btn btn-primary mt-3 ms-3"
                    style={{ opacity: isLoading ? 0.5 : 1 }}
                    onClick={() => {
                        handlePayment()
                    }}
                >
                    Try again
                </Button> */}
            </div>
        </div>
    )
}

export default CheckoutForm
